<template>
  <div>
    <div class="dio_img">
      <div class="dio_eage" v-if="getStor">
        <img src="@a/eage1_1.png" alt="" @click="img_s(1)" v-show="img_show" />
        <img src="@a/eage2_1.png" alt="" @click="img_s(2)" v-show="!img_show" />
      </div>
      <div class="dio-talk"  @click="dio_click">
        <div class="dio-talk-left">
          <h2>进入自我对话</h2>
          <h3>#通过自由书写聆听内心的声音#</h3>
        </div>
        <img  src="@a/task_right.png" alt="">
      </div>
      <!-- <img src="@a/dio_img.png" alt="" @click="dio_click" /> -->
    </div>
    <van-popup v-model="list_show">
      <div class="list">
      </div>
    </van-popup>
  </div>
</template>
<script>
import { getStorage, setStorage } from "@/utils/tools"
export default {
  data() {
      return {
        img_show: true,
         getStor: true
      }
    },
    props: {
      testid: {
        default: ''
      },
      cid: {
        default: ''
      },
      taskid: {
        default: ''
      }
    },
    methods: {
      dio_click() {
        this.$router.push({
          path: '/course_dialogue',
          query: {
            testid: this.testid,
            cid: this.cid,
            taskid: this.taskid
          }
        })
      },
      img_s(num) {
        if (num == 1) {
          this.img_show = false;
        }else {
          this.getStor = false;
          setStorage(this.$route.path, 'testid'+ this.testid, 1);
        }
      }
    },
    created(){
      this.getStor = getStorage(this.$route.path, 'testid'+ this.testid) === 1 ? false: true;
    }
}
</script>
<style lang="scss" scoped>
.dio_img {
  margin-top: 36px;
  img {
    width: 100%;
  }
  .dio_eage {
    position: fixed;
    top: 50%;
    transform: translate(-50%,-50%);
    left: 50%;
    max-width: 750px;
    width: 100%;
    height: 100%;
    z-index: 999;
    img {
      width: 100%;
      height: 100%;
    }
  }
  .dio-talk{
    height: 160px;
    display: flex;
    align-items: center;
    background-color: #E5E9F2;
    border-radius:8px;
    padding: 0 30px;
    .dio-talk-left{
      text-align: left;
      h2{
        font-size: 36px;
        line-height: 1;
        margin-bottom: 17px;
        text-align: left;
      }
      h3{
        line-height: 1;
        font-size: 26px;
        text-align: left;
      }
    }
    img{
      width: 14px;
      height: 24px;
      margin-left: auto;
    }
  }
}
</style>
